var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSwapFreeAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8607 1.73168C9.24818 1.32055 7.54485 1.45934 6.01982 2.12617C4.82812 2.64725 3.79833 3.46757 3.02549 4.5H6V5.5H1.5V1H2.5V3.55262C3.33924 2.54568 4.405 1.74084 5.61919 1.20993C7.34818 0.45392 9.27945 0.296533 11.1078 0.762682C12.9361 1.22883 14.557 2.29188 15.7146 3.78367C16.8721 5.27545 17.5003 7.11093 17.5 9.00008L16.5 8.99992C16.5003 7.33266 15.9458 5.71295 14.9245 4.39671C13.9032 3.08049 12.4732 2.14282 10.8607 1.73168Z",
    fill: "#00AD7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28543 14.2163C1.1279 12.7246 0.499712 10.8891 0.5 8.99994L1.5 9.00009C1.49975 10.6674 2.05416 12.2871 3.07549 13.6033C4.0968 14.9195 5.52675 15.8572 7.13929 16.2683C8.75182 16.6795 10.4551 16.5407 11.9802 15.8738C13.1719 15.3528 14.2017 14.5324 14.9745 13.5H12V12.5H16.5V17H15.5V14.4474C14.6608 15.4543 13.595 16.2592 12.3808 16.7901C10.6518 17.5461 8.72055 17.7035 6.89224 17.2373C5.06393 16.7712 3.44298 15.7081 2.28543 14.2163Z",
    fill: "#00AD7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwapFreeAccount);
export default __webpack_public_path__ + "static/media/icon-swapFreeAccount.1d568790fc164d9f47d72e35e18cc34d.svg";
export { ForwardRef as ReactComponent };